(() => {
  function setup(root = document) {
    root.querySelectorAll('.sp-mobile-menu:not([data-sp-ready])').forEach(menu => {
      menu.dataset.spReady = 'true';
      menu.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => { menu.open = false; });
      });
    });
    root.querySelectorAll('.sp-product-form:not([data-sp-ready])').forEach(form => {
      form.dataset.spReady = 'true';
      const select = form.querySelector('[data-sp-variant]');
      const card = form.closest('.sp-card');
      const button = form.querySelector('.sp-add');
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        card.querySelector('[data-sp-price]').textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        const image = card.querySelector('.sp-product-image');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sp-mobile-menu[open]').forEach(menu => { menu.open = false; });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.sp-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
